<template>
  <q-dialog
    v-model="show"
    :maximized="maximized"
    @input="(val) => $emit('input', val)"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
      <q-header>
        <q-toolbar>
          <q-toolbar-title>{{ label }}</q-toolbar-title>
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
      </q-header>

      <q-page-container class="scroll page-container">
        <crud-form
          v-if="forms"
          ref="crudForm"
          :form="forms[0]"
          :model="forms[0].dadosForm"
          @action-click="actionClick"
        >
          <q-stepper
            animated
            v-model="currentStep"
            ref="stepper"
            color="primary"
            class="tw-h-full"
          >
            <q-step
              :name="0"
              :title="$gettext('PERIOD_STEP')"
              :done="step > 0"
              class="no-scroll-step"
            >
              <div class="row q-col-gutter-md">
                <crud-input
                  class="col-12"
                  nmInput="concessionContractTariff"
                  @on-select-change="onSelectChangeHandler"
                  :required="true"
                />
                <crud-input
                  class="col-12"
                  nmInput="observation"
                  :required="true"
                />
              </div>
            </q-step>
            <q-step
              :name="1"
              :title="$gettext('INVOICES_SUMMARY_STEP')"
              :done="step > 1"
              class="scroll-step"
            >
              <div class="table-container">
                <compositions :hideCompositions="['invoiceSettlementFiles']">
                  <composition
                    slot="invoiceSettlementInvoices"
                    slot-scope="dados"
                    v-bind="dados"

                  >
                    <template slot="table" slot-scope="dadosTable">
                      <service-request-invoice-settlement-datable
                        :fields="dadosTable.fields"
                        :invoices="invoices"
                        noneselect
                        rowKey="boundResidue"
                        :columnEdit="paintCell"
                      />
                    </template>
                  </composition>
                </compositions>
              </div>
            </q-step>

            <q-step
              :name="2"
              :title="$gettext('ATTACHMENT_INFO_STEP')"
              :done="step > 2"
              class="no-scroll-step"
            >
              <div id="attachment-info">
                <compositions :hideCompositions="['invoiceSettlementInvoices']"  >
                  <composition
                  slot="invoiceSettlementFiles"
                  slot-scope="dados"
                  ref="composition"
                  v-bind="dados"/>
                </compositions>
              </div>
            </q-step>
          </q-stepper>
        </crud-form>
      </q-page-container>

      <q-footer class="footer-container">
        <div class="footer-content">
          <q-btn
            v-if="currentStep > 0"
            class="tw-w-auto tw-px-6 tw-shrink-0 tw-whitespace-nowrap"
            :label="$gettext('BACK')"
            color="grey-7"
            @click="prevStep"
          />
          <q-btn
            class="tw-w-auto tw-px-6 tw-shrink-0 tw-whitespace-nowrap"
            :label="
              isLastStep ? $gettext('SEND_TO_APPROVAL') : $gettext('CONTINUE')
            "
            color="info"
            @click="nextStep"
            :disable="isStepInvalid || invoices.length === 0"
          />
        </div>
      </q-footer>
    </q-layout>
  </q-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDynamicForm, JtCrud } from 'jtech-webcomps'
import ServiceRequestInvoiceSettlementController from './ServiceRequestInvoiceSettlementController'
import ServiceRequestController from '../../../../ServiceRequestController'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import { QBtn } from 'quasar'
import InvoiceSituation from '../component/InvoiceSituation.vue'
import { situationMap } from '../../invoice/component/situation.config'
import moment from 'moment'
import ServiceRequestInvoiceSettlementDatable from './ServiceRequestInvoiceSettlementDatatable.vue'
import ServiceRequestModel from '../../../../ServiceRequestModel'

const { form, input, compositions, composition } = JtCrud

const INTERFACE_NAMES = {
  CONCESSION_CONTRACT_TARIFF: 'concessionContractTariff',
  OBSERVATION: 'observation'
}

const createErrorMessages = (vm) => ({
  LOAD_ERROR: vm.$gettext('ERROR_LOADING_DATA'),
  PROCESS_INVOICES_ERROR: vm.$gettext('ERROR_PROCESSING_INVOICES'),
  APPLY_EXEMPTION_ERROR: vm.$gettext('ERROR_APPLYING_EXEMPTION'),
  GET_LABEL_ERROR: vm.$gettext('ERROR_GETTING_LABEL'),
  DETAIL_ERROR: vm.$gettext('ERROR_DETAIL_RECORD')
})

@Component({
  name: 'ServiceRequestInvoiceSettlementExemption',
  components: {
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition,
    MainContentLayout,
    QBtn,
    JtDataTable,
    JtDynamicForm,
    InvoiceSituation,
    ServiceRequestInvoiceSettlementDatable
  },
  props: {
    consumerUnit: String,
    protocol: String,
    label: String,
    show: {
      type: Boolean,
      default: false
    },
    maximized: {
      type: Boolean,
      default: false
    }
  }
})
class ServiceRequestInvoiceSettlementExemption extends Vue {
  controller = ServiceRequestController.getInstance();
  serviceRequestInvoiceSettlementController =
    ServiceRequestInvoiceSettlementController.getInstance();

  forms = null;
  invoices = [];
  nominalValueLabel = null;
  nominalValue = 0.0;
  loading = false;
  moment = moment;

  currentStep = 0;
  lastStep = 2;

  modalData = null;

  static INTERFACES = INTERFACE_NAMES;

  ERROR_MESSAGES = null;
  state = ServiceRequestModel.getInstance();

  created () {
    this.ERROR_MESSAGES = createErrorMessages(this)
  }

  get invoicesForm () {
    const form = this.forms?.[0]
    if (!form) return null
    return {
      ...form,
      inputs: form.inputs.filter(
        (input) => input.model === 'invoiceSettlementInvoices'
      ),
      dadosForm: {
        invoiceSettlementInvoices: form.dadosForm.invoiceSettlementInvoices
      }
    }
  }

  get owner () {
    return this._consumerUnit?.ownerId
  }

  get _consumerUnit () {
    return this._serviceRequest?.consumerUnits[this.consumerUnit]
  }

  get _serviceRequest () {
    return this.controller?.state?.serviceRequests[this.protocol]
  }

  async mounted () {
    try {
      await this.load()
      this.nominalValueLabel = this.getLabelInput('nominalValue')
    } catch (error) {
      this.$messageBox.showError(this.$gettext('ERROR_LOADING_DATA'))
      console.error('Error mounting component:', error)
    }
  }

  async load () {
    this.forms =
      await this.serviceRequestInvoiceSettlementController.createdBillingExemption(
        this.consumerUnit
      )
  }

  async apply () {
    if (!this.$refs.composition.isValid) {
      this.$messageBox.showWarning(this.$gettext('FULFILL_FIELDS_MESSAGE'))
      return
    }

    const params = {
      ...this.forms[0].dadosForm,
      nominalValue: this.nominalValue,
      consumerUnit: this.consumerUnit,
      owner: this.owner,
      invoiceSettlementInvoices: this.invoices
    }

    try {
      this.loading = true
      await this.serviceRequestInvoiceSettlementController.applyExemption(params)
      this.$emit('input', false)
    } catch (error) {
      this.$messageBox.showWarning(this.$gettext('ERROR_APPLYING_EXEMPTION'))
      console.error(`${this.ERROR_MESSAGES.APPLY_EXEMPTION_ERROR}:`, {
        error,
        params
      })
    } finally {
      this.loading = false
    }
  }

  getLabelInput (nmInput) {
    try {
      return this.forms[0].inputs.find((input) => nmInput === input.model)
        .label
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.GET_LABEL_ERROR}:`, {
        error,
        nmInput,
        availableInputs: this.forms[0]?.inputs?.map((i) => i.model)
      })
      return nmInput
    }
  }

  isConcessionContractTariff (fieldName) {
    return fieldName === INTERFACE_NAMES.CONCESSION_CONTRACT_TARIFF
  }

  async onSelectChangeHandler (field) {
    if (this.isConcessionContractTariff(field.input.name)) {
      try {
        const value = field.selectedValue
        const { invoices } =
          await this.serviceRequestInvoiceSettlementController.processInvoices(
            this.consumerUnit,
            value,
            this.state.serviceRequests[this.$props.protocol].client
          )
        if (invoices.length === 0) {
          this.$messageBox.showWarning(this.$gettext('NO_INVOICES_FOUND_MESSAGE'))
          return
        }
        this.invoices = invoices
      } catch (error) {
        console.error(`${this.ERROR_MESSAGES.PROCESS_INVOICES_ERROR}:`, {
          error,
          consumerUnit: this.consumerUnit,
          selectedValue: field.selectedValue,
          fieldName: field.input.name
        })
      }
    }
  }

  async handleTableAction (event, clickedRecord, dadosTable) {
    if (event.name === 'icDetalharComposicao') {
      try {
        const forms = await this.serviceRequestInvoiceSettlementController.detail(
          event.action,
          clickedRecord
        )

        this.modalData = {
          show: true,
          forms,
          label: event.label,
          params: clickedRecord,
          detail: true
        }
      } catch (error) {
        console.error(`${this.ERROR_MESSAGES.DETAIL_ERROR}:`, {
          error,
          method: 'handleTableAction',
          event,
          clickedRecord
        })
        throw error
      }
    } else {
      dadosTable.actionButton(event, clickedRecord, this)
    }
  }

  get isLastStep () {
    return this.currentStep === this.lastStep
  }

  get isStepInvalid () {
    if (this.currentStep === 0) {
      return (
        !this.forms?.[0]?.dadosForm?.concessionContractTariff ||
        !this.forms?.[0]?.dadosForm?.observation
      )
    }
    return false
  }

  nextStep () {
    if (this.isLastStep) {
      this.apply()
    } else {
      this.currentStep++
    }
  }

  prevStep () {
    this.closeDetailModal()
    this.closeFileModal()
    this.currentStep--
  }

  closeDetailModal () {
    if (this.modalData) {
      this.modalData.show = false
    }
  }

  closeFileModal () {
    if (this.$refs.fileModal) {
      this.$refs.fileModal.hide()
    }
  }

  get situationMap () {
    return situationMap
  }
}

export default ServiceRequestInvoiceSettlementExemption
</script>

<style lang="stylus" scoped>
.modal-medium {
  min-height: 600px;
  max-height: 100vh;
  background-color: white;
}

:deep(.q-page-container) {
  height: calc(100vh - 120px);
  padding-bottom: 80px;
  box-shadow: none !important;
  background: transparent;
  overflow: hidden;

  &:after {
    display: none;
  }
}

:deep(.q-stepper) {
  height: 100%;
  overflow: hidden;
}

:deep(.q-stepper__content) {
  padding: 24px;
}

:deep(.no-scroll-step) {
  overflow: hidden;

  .q-step-content {
    overflow: hidden;
  }
}

:deep(.scroll-step) {
  .q-step-content {
    overflow: hidden;
    position: relative;
    height: 100%;

    .table-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 80px;
      overflow-y: auto;
      padding: 24px;
      padding-bottom: 0;
    }
  }
}

.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: white;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.footer-content {
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.page-container {
  max-height: 85vh;
}

#attachment-info .jt-composition-container #jt-composition .jt-datatable {
  width: auto !important;
}
</style>
